/** Preserve diagnostic messages while removing credentials and URL query data. */
export function scrubTelemetryText(value: string, credentials: readonly string[] = []): string {
  for (const credential of credentials) if (credential.length >= 8) value = value.split(credential).join("[REDACTED]")
  return value
    .replace(/https?:\/\/[^\s<>"']+/g, (raw) => {
      try { const url = new URL(raw); url.username = ""; url.password = ""; url.search = ""; url.hash = ""; return url.toString() } catch { return "[invalid URL]" }
    })
    .replace(/\b(Bearer|Basic)\s+[A-Za-z0-9._~+/=-]+/gi, "$1 [REDACTED]")
    .replace(/\b(sk-[A-Za-z0-9_-]{12,}|gh[pousr]_[A-Za-z0-9_]{12,}|xox[abeprs]-[A-Za-z0-9-]+|xoxe\.[A-Za-z0-9.-]+|xapp-[A-Za-z0-9-]+|phc_[A-Za-z0-9_]+|eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+)/g, "[REDACTED]")
    .replace(/\b(password|secret|token|api[_-]?key|authorization)\s*[:=]\s*["']?[^\s,;"']+/gi, "$1=[REDACTED]")
    .slice(0, 8192)
}

export function telemetryError(error: unknown, credentials: readonly string[] = []): Error {
  try {
    const safe = new Error(scrubTelemetryText(error instanceof Error ? error.message : String(error), credentials))
    if (error instanceof Error) {
      safe.name = /^[A-Za-z][\w.:-]{0,79}$/.test(error.name) ? error.name : "Error"
      if (error.stack) safe.stack = scrubTelemetryText(error.stack, credentials)
    }
    return safe
  } catch { return new Error("Error details unavailable.") }
}
